import { forwardRef, memo, HTMLProps } from 'react'
import { useSelector } from 'react-redux'
import { H1, Typography, Divider } from '@vp/swan'

import { getH1Title, booleanRenderPropertySelector } from 'client/store/config'
import { RenderProperty } from 'shared/renderProperties'
import { getMetadata } from 'client/store/config/reducer'
import { BreadcrumbsContainer } from 'client/components/Gallery/Header/BreadcrumbsContainer'
import { RatingsSummary } from 'client/components/Gallery/Header/RatingsSummary'
import { useRatingsAndReviews } from '~/client/hooks/useRatingsAndReviews'
import { SetHighlightingHeader } from '~/client/components/Gallery/SetHighlighting/SetHighlightingHeader'
import { getShowSets } from '~/client/store/debug'

export const HeroHeader = memo(
  forwardRef<HTMLDivElement, HTMLProps<HTMLDivElement>>((props, ref) => {
    const h1Title = useSelector(getH1Title)
    const booleanRenderProperty = useSelector(booleanRenderPropertySelector)
    const galleryMetadata = useSelector(getMetadata)
    const showSets = useSelector(getShowSets)
    const hasValidBreadcrumbs = galleryMetadata?.hasValidBreadcrumbs

    const showBreadcrumbs = booleanRenderProperty(RenderProperty.ShowBreadcrumbs)
    const showProductHeaderInfo = booleanRenderProperty(RenderProperty.ShowProductHeaderInfo)

    const ratingsAndReviews = useRatingsAndReviews()

    return (
      <section className="gallery-hero-header" {...props} ref={ref}>
        <div className="hero-container">
          {showBreadcrumbs && hasValidBreadcrumbs && <BreadcrumbsContainer />}
          <div className="title-primary">
            {!!h1Title && (
              <H1 fontSkin="title-headline" data-testid="page-title">
                {h1Title}
              </H1>
            )}
            {showProductHeaderInfo && !!galleryMetadata && !!galleryMetadata?.primaryContent && (
              <div className="main-content-container">
                <Typography className="main-content">{galleryMetadata?.primaryContent}</Typography>
              </div>
            )}
          </div>
          {showSets && <SetHighlightingHeader />}
          {ratingsAndReviews && <RatingsSummary {...ratingsAndReviews} />}
          <Divider mt="6" />
        </div>
      </section>
    )
  }),
)

HeroHeader.displayName = 'HeroHeader'
